import { render } from "./index.vue?vue&type=template&id=48a8b760&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=48a8b760&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a8b760"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';import TouchSwipe from 'quasar/src/directives/touch-swipe/TouchSwipe.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});qInstall(script, 'directives', {TouchSwipe});
